(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nx-cod-button"] && !Shopify.designMode) return;
  try {
    if (!window.nxCodScrollBound) {
    window.nxCodScrollBound = true;
    document.addEventListener('click', (event) => {
      const appTrigger = event.target.closest('[data-nx-app-trigger]');
      if (!appTrigger) return;
      const appButton = document.querySelector(
        '._rsi-buy-now-button-product:not(._rsi-buy-now-button-product-floating)'
      );
      if (!appButton || appButton.contains(appTrigger)) return;
      event.preventDefault();
      appButton.click();
    });
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-nx-scroll-cod]');
      if (!trigger) return;
      const slot = document.querySelector('[data-nx-cod-slot]');
      if (!slot) return;
      event.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      slot.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      const focusable = slot.querySelector('input, select, button, a[href]');
      if (focusable) focusable.focus({ preventScroll: true });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-gallery-marks"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nx-variant-live')) {
    customElements.define(
      'nx-variant-live',
      class extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.shopify-section');
          if (!this.section) return;
          this.onSelect = (event) => {
            if (!event.promise || event.target.closest?.('product-card')) return;
            event.promise
              .then(({ detail }) => {
                const next = detail?.html?.querySelector(`[data-nx-live="${this.dataset.nxLive}"]`);
                if (next) this.innerHTML = next.innerHTML;
              })
              .catch(() => {});
          };
          this.section.addEventListener('shopify:product:select', this.onSelect);
        }

        disconnectedCallback() {
          this.section?.removeEventListener('shopify:product:select', this.onSelect);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
